import { GraduationCapIcon } from "lucide-react";

import { Education } from "./Education";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { SheetSectionHeader } from "@/components/SheetSectionHeader";
import { EducationType } from "@/types";

export const EducationSheetContent = ({
  educations,
}: {
  educations: EducationType[];
}) => {
  /* Render */
  const renderContent = () => {
    if (!educations.length) {
      return (
        <SheetSectionEmptyText text="This candidate hasn't added any educational background." />
      );
    }

    return (
      <Column className="gap-4">
        {educations.map((education) => (
          <Education education={education} key={education.id} />
        ))}
      </Column>
    );
  };

  const render = () => {
    return (
      <Column className="gap-6 border-t border-slate-200 py-6">
        <Row className="items-center justify-between">
          <SheetSectionHeader icon={GraduationCapIcon} title="Education" />
        </Row>
        {renderContent()}
      </Column>
    );
  };

  return render();
};
